module.exports = "<order-summary-header ctrl=\"ctrl\"></order-summary-header>\n<hr class=\"hr--thin\"/>\n<order-summary-items ctrl=\"ctrl\" lines=\"diner.lines\"></order-summary-items>\n<diner-summary-totals ctrl=\"ctrl\" diner=\"diner\"></diner-summary-totals>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/home/receipt/sections/dinerSummaryCustomer.html
// module id = 783
// module chunks = 0